import type { Auth0ContextInterface } from '@auth0/auth0-react';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export let resolveAuth0Client: (client: Auth0ContextInterface) => void;
export const auth0Client: Promise<Auth0ContextInterface> = new Promise(
  (resolve) => {
    resolveAuth0Client = resolve;
  }
);
